<template>
  <ms-dynamic-popup
    title="Tham số in chứng từ"
    classTitle="report-param-title"
    :width="930"
    dockPosition="right"
    @beforeOpen="beforeOpen($event, close)"
    @beforeClose="beforeClose"
    classDetail="report-param-payment-voucher-list-print-from-voucher-nd112020"
    @shortkeyAction="shortkeyAction"
    :name="'ReportParam_payment-voucher-list-print-from-voucher-nd112020'"
    ><template v-slot:icon>
      <a
        class="button icon24 ic-question mr-2"
        v-tooltip="'Trợ giúp'"
        shortkey-target="Help"
        target="_blank"
        :href="linkHelp($ms.constant.Help.VoucherReport)"
      ></a>
    </template>
    <template v-slot:content>
      <div class="flex flex-column" style="overflow: auto">
        <div class="report-body flex1 ml-3 mr-3">
          <div class="flex-column mt-1">
            <div class="control-title">
              <label class="label">Hiển thị mã nguồn</label>
            </div>
            <div class="flex-row mt-1">
              <ms-radio
                label="Mã nguồn ngân sách"
                name="rdShowBudgetSource"
                :keyValue="1"
                v-model="model.show_budget_source_property"
                class="left"
              ></ms-radio>
              <ms-radio
                label="Tính chất nguồn kinh phí"
                name="rdShowBudgetSource"
                :keyValue="2"
                v-model="model.show_budget_source_property"
                class="flex1 left ml-8"
              ></ms-radio>
            </div>
          </div>

          <div class="flex-row width-595 mt-1">
            <div class="flex-column flex2">
              <div class="control-title label">
                <label class="label">Kèm theo</label>
              </div>
              <ms-combobox-enum
                class="flex1 mt-1"
                enum="AttachNote"
                v-model="model.attach_note"
                :initText="
                  $ms.format.formatData(model.attach_note, {
                    formatType: 100,
                    enumName: 'AttachNote',
                  })
                "
                :rules="[{name: $ms.constant.ValidateRule.Required}, {name: $ms.constant.ValidateRule.ForceSelection}]"
              ></ms-combobox-enum>
            </div>
            <div class="flex-column flex1 ml-2">
              <div class="control-title label">
                <label class="label">Số</label>
              </div>
              <ms-input v-model="model.note" :maxLength="50" class="mt-1"></ms-input>
            </div>
          </div>
          <div class="flex-row title-3 mt-1" @click="changeShowDisplay">
            <div class="icon-combo--dropdown" :class="[showDisplay ? 'expand' : '']"></div>
            <div class="title-text">Tùy chọn hiển thị</div>
          </div>
          <div class="report-teb" v-show="showDisplay">
            <div class="flex-row mt-1">
              <ms-checkbox
                class="flex1 left"
                label="In mỗi khoản là 01 trang"
                v-model="model.print_sub_kind_item"
              ></ms-checkbox>
              <ms-checkbox class="flex1 ml-2" label="In ngày chứng từ" v-model="model.print_date_voucher"></ms-checkbox>
            </div>
            <div class="flex-row mt-1">
              <ms-checkbox
                class="flex1 left"
                label="In mỗi tính chất nguồn là 01 trang"
                v-model="model.print_budget_source_property"
              ></ms-checkbox>
              
              <ms-checkbox
                class="flex1 ml-2"
                label="Không hiển thị dòng tổng theo tiểu mục"
                v-model="model.not_show_summary_budget_sub_item"
              ></ms-checkbox>
            </div>
            <div class="flex-row mt-1">
              <ms-checkbox
                class="flex1 left"
                label="In mỗi mục là 01 chứng từ"
                v-model="model.is_detail_budget_item"
              ></ms-checkbox>

              <ms-checkbox class="flex1 ml-2" label="Hiển thị đơn vị tiền tệ" v-model="model.show_unit"></ms-checkbox>
            </div>

            <div class="flex-row mt-1">
            </div>
            <div class="flex-row mt-1">
              <div class="width-595">
                <div class="control-title label">
                  <label class="label">Hiển thị cột ngày, số chứng từ gốc</label>
                </div>
                <ms-combobox-enum
                  class="flex1 mt-1"
                  :forceSelection="false"
                  enum="ShowDateAndRefNo"
                  v-model="model.date_and_ref_no"
                  :initText="
                    $ms.format.formatData(model.date_and_ref_no, {
                      formatType: 100,
                      enumName: 'ShowDateAndRefNo',
                    })
                  "
                  :rules="[{name: $ms.constant.ValidateRule.Required}]"
                  :values="showDateAndRefNoCustom"
                ></ms-combobox-enum>
              </div>
              <div class="flex1 ml-2"></div>
            </div>
            <div class="flex-row mt-1"></div>
          </div>
          <div class="flex-row title-3">
            <div class="icon-combo--dropdown" :class="[showPayment ? 'expand' : '']" @click="changePayment"></div>
            <div class="title-text" @click="changePayment">Nhập nội dung thanh toán</div>
            <div class="flex1 flex-row">
              <div class="flex"></div>
              <div class="get-default flex-row" v-show="showPayment" @click="getDefaultData(model, true)">
                <div class="icon24 back-default"></div>
                <div>Lấy lại số liệu từ chứng từ gốc</div>
              </div>
            </div>
          </div>
          <div class="flex-row flex1 mt-1" v-show="showPayment">
            <ms-grid-editor
              ref="Details"
              :data="details"
              class="flex-box flex1"
              v-model:list="details"
              v-model:selected="gridInfo.selected"
              idField="ref_detail_id"
              greyTitle
              :footer="true"
              :lockable="false"
              :sortable="false"
              :columns="columnDetails"
              titleFooter="Tổng"
              multiple
              :propsData="propsData"
              :changeTriggers="['quantity', 'unitprice', 'norm']"
              @updateBusiness="changeDataBusiness"
            ></ms-grid-editor>
          </div>
        </div>
      </div>
    </template>
    <template v-slot:footer="{close}">
      <div class="h-100 flex-between flex1">
        <div></div>
        <div class="d-flex" style="flex-direction: row-reverse">
          <ms-button text="Đồng ý" @click="commandClick($ms.constant.Command.Ok)"></ms-button>
          <ms-button
            text="Hủy"
            type="outline-button"
            v-tooltip="'Hủy (Ctrl + H)'"
            shortkey-target="Cancel"
            hasBorder
            @click="close"
            style="margin-right: 10px"
          ></ms-button>
        </div>
      </div>
    </template>
  </ms-dynamic-popup>
</template>

<script>
import {defineComponent, getCurrentInstance, reactive, ref, onMounted, watch, computed, nextTick} from 'vue';
import baseVoucherReportParam from '@/views/base/baseVoucherReportParam';
import {ModuleContext} from '@/stores/moduleConst';
import {mapGetters} from 'vuex';
import commonFn from '@/commons/commonFunction';
import popupUtil from '@/commons/popupUtil';
import api from '@/apis/report/voucherReportPrintAPI';
import {showError} from '@/commons/globalMessage';
import msGridEditor from '@/components/gridEditor/MsGridEditor.vue';
import {useInforCommons} from '@/views/utility/commons/inforCommons.js';
import _ from 'lodash';
import {collectionMonitor} from '@/setup/utilities/monitor';

export default defineComponent({
  components: {
    msGridEditor,
  },
  extends: baseVoucherReportParam,
  setup() {
    const {proxy} = getCurrentInstance();

    /**Khai báo một số config lưu cache tham số in lần trước */
    const isSaveFormat = true; //Có lưu tham số in lần trước theo loại chứng từ không
    const isSaveCommon = true; //Có lưu tham số in lần trước theo báo cáo không
    const reportIdCommon = proxy.$ms.constant.ReportId.BC_56_01_ND11_2020; //Id chung cho báo cáo có 2 loại mẫu ngang, mẫu dọc cần lưu chung tham số in lần trước theo mẫu báo cáo

    const comboboxDataRemote = reactive({});
    const model = reactive({
      show_budget_source_property: 1,
      attach_note: 'All',
      note: '',
      lower_aquater_page: false,
      repeat_title_signature: false,
      print_date_voucher: false,
      print_sub_kind_item: false,
      print_budget_source_property: false,
      add_transfer: false,
      show_unit: false,
      row_per_page: 10,
      add_empty_row: 0,
      date_and_ref_no: 'date_and_ref_no',
      not_show_summary_budget_sub_item: false,
      is_detail_budget_item: false,
    });
    proxy._gridDetails = {
      details: 'Details',
    };
    const showDisplay = ref(true);
    const showPayment = ref(true);

    const details = ref([]);
    const changeShowDisplay = () => {
      showDisplay.value = !showDisplay.value;
      proxy.$nextTick(() => {
        if (!showDisplay.value) {
          proxy.$refs.Details.updateFooterContainer();
        }
      });
    };
    const changePayment = () => {
      showPayment.value = !showPayment.value;
    };

    const columnDetails = reactive(initGridColumnDetail());
    function initGridColumnDetail() {
      return [
        {
          caption: 'Nội dung chi',
          title: 'Nội dung chi',
          dataField: 'description',
          width: 210,
          columnType: proxy.$ms.constant.ColumnType.Text,
          editable: true,
        },
        {
          caption: 'Mã NDKT',
          title: 'Mã nội dung kinh tế',
          dataField: 'budget_sub_item_code',
          columnType: proxy.$ms.constant.ColumnType.Text,
          width: 70,
          editable: false,
        },
        {
          caption: 'Mã ngành KT',
          title: 'Mã ngành kinh tế',
          dataField: 'budget_sub_kind_item_code',
          width: 100,
          columnType: proxy.$ms.constant.ColumnType.Text,
          editable: false,
        },
        {
          caption: 'Số lượng',
          dataField: 'quantity',
          width: 80,
          editable: true,
          columnType: proxy.$ms.constant.ColumnType.Number,
          formatType: proxy.$ms.constant.FormatType.Quantity,
        },
        {
          caption: 'Định mức',
          dataField: 'norm',
          width: 80,
          editable: true,
          columnType: proxy.$ms.constant.ColumnType.Number,
          formatType: proxy.$ms.constant.FormatType.UnitPrice,
        },
        {
          caption: 'Đơn giá thực tế',
          dataField: 'unitprice',
          width: 100,
          editable: true,
          columnType: proxy.$ms.constant.ColumnType.Number,
          formatType: proxy.$ms.constant.FormatType.UnitPrice,
        },
        {
          caption: 'Thành tiền',
          dataField: 'amount',
          autoResize: true,
          editable: false,
          columnType: proxy.$ms.constant.ColumnType.Number,
          formatType: proxy.$ms.constant.FormatType.Amount,
          summaryType: proxy.$ms.constant.SummaryType.Sum,
        },
      ];
    }
    const showDateAndRefNoCustom = ref([]);
    async function bindData(data) {
      data.ref_type = proxy._formParam?.dataModel?.ref_type;
      data.ref_id = proxy._formParam?.dataModel?.ref_id;

      data.$RefType = proxy._formParam?.dataModel?.ref_type;
      data.$ListRefID = proxy._formParam?.dataModel?.ref_id;
      data.attach_note = data.attach_note || 'All';
      const showDateAndRefNo = _.cloneDeep(proxy.$ms.constant.ShowDateAndRefNo);
      if (showDateAndRefNo) {
        showDateAndRefNoCustom.value = Object.values(showDateAndRefNo);
      }
      await getDefaultData(data);
      switch (data.ref_type) {
        case proxy.$ms.constant.RefType.BUVoucherListPlanned:
        case proxy.$ms.constant.RefType.BUVoucherListNotPlanned:
        case proxy.$ms.constant.RefType.BUVoucherListReceipExpense:
        case proxy.$ms.constant.RefType.BUVoucherListOther:
        case proxy.$ms.constant.RefType.BUVoucherListRealExpense:
          break;
        default:
          showDateAndRefNoCustom.value = showDateAndRefNoCustom.value.filter(x => x != 'date_and_ref_no_bu_voucher');
          break;
      }
      proxy.super('bindData', baseVoucherReportParam, data);
    }

    const {getModuleByRefType} = useInforCommons();
    /**
     * Lấy dữ liệu mặc định
     * dqdat1 18.10.2022
     */
    async function getDefaultData(data, getDefault) {
      var detailKey = 'Detail'
      let voucher = proxy._formParam.dataModel;
      if (voucher != null) {
        data.ref_date = voucher.ref_date;
        data.posted_year = voucher.posted_date?.getFullYear() || proxy.postedDate?.getFullYear();
        let dataVoucher = [];
        voucher[detailKey] = voucher[detailKey].filter(x => x.state != proxy.$ms.constant.ModelState.Empty && x.state != proxy.$ms.constant.ModelState.Delete);
        voucher[detailKey]
          .sort(function (a, b) {
            return a.sort_order - b.sort_order;
          })
          .sort(function (a, b) {
            return a.budget_sub_kind_item_code - b.budget_sub_kind_item_code;
          })
          .sort(function (a, b) {
            return a.budget_sub_item_code - b.budget_sub_item_code;
          })
          .forEach(x => {
            let unitprice = x.unitprice || x.unit_price;
            if (filterDetailByAccount(voucher, x)) {
              return;
            }

            // Không lấy các dòng chi tiết đã thanh toán
            if (
              (voucher.ref_type == proxy.$ms.constant.RefType.BUVoucherListPlanned ||
                voucher.ref_type == proxy.$ms.constant.RefType.BUVoucherListNotPlanned ||
                voucher.ref_type == proxy.$ms.constant.RefType.BUVoucherListReceipExpense) &&
              x.is_treasury_approved
            ) {
              return;
            }

            let amountDetail = x.amount;
            if ([proxy.$ms.constant.RefType.BAWithdrawPurchase].includes(data.ref_type)) {
              amountDetail = (x.amount || 0) + (x.tax_amount || 0);
            } else if ([proxy.$ms.constant.RefType.BAWithDrawFixedAsset].includes(data.ref_type)) {
              amountDetail = (x.amount || 0) + (x.tax_amount || 0);
            }

            let item = {
              norm: x.norm || 0,
              amount: amountDetail,
              checked: true,
              quantity: x.quantity || 0,
              unitprice: unitprice || 0,
              description: x.description || '',
              ref_detail_id: x.ref_detail_id,
              budget_sub_item_code: x.budget_sub_item_code,
              cash_withdraw_type_id: x.cash_withdraw_type_id || null,
              budget_sub_kind_item_code: x.budget_sub_kind_item_code,
            };
            dataVoucher.push(item);
          });

        if (JSON.stringify(dataVoucher) == JSON.stringify(data.Details)) {
          if (getDefault) {
            details.value = JSON.parse(JSON.stringify(dataVoucher));
          } else {
            details.value = JSON.parse(data.JsonDetail || JSON.stringify(dataVoucher));
          }
        }
        //NVTUAN1 25.04.2023: Nếu là convert từ desktop sang thì luôn lấy dữ liệu ở JsonDetail nếu có
        else if (data.isDataConvert) {
          details.value = JSON.parse(data.JsonDetail || JSON.stringify(dataVoucher));
        } else {
          details.value = JSON.parse(JSON.stringify(dataVoucher));
        }
        data.Details = JSON.parse(JSON.stringify(dataVoucher));
      }
    }

    function filterDetailByAccount(voucher, x) {
      // Chuyển khoản kho bạc
      // Chuyển khoản kho bạc trả lương
      // Chuyển khoản lương
      // Chuyển khoản thanh toán bảo hiểm
      if (
        (voucher.ref_type == proxy.$ms.constant.RefType.BUTransfer ||
          voucher.ref_type == proxy.$ms.constant.RefType.BUTreasuryFundTransferSalary ||
          voucher.ref_type == proxy.$ms.constant.RefType.BUTreasuryFundTransferInsurancePayment ||
          voucher.ref_type == proxy.$ms.constant.RefType.BUTransferSalary) &&
        !(
          x.credit_account.startsWith('511') ||
          x.credit_account.startsWith('337') ||
          x.credit_account.startsWith('366')
        )
      ) {
        return true;
      }
      // Chi tiền gửi mua Vật tư, hàng hóa
      if (
        voucher.ref_type == proxy.$ms.constant.RefType.BAWithdrawPurchase &&
        !(x.debit_account == '152' || x.debit_account == '153' || x.debit_account == '155' || x.debit_account == '156')
      ) {
        return true;
      }

      // Phiếu chi thông thường
      // Chuyển khoản thanh toán bảo hiểm
      if (voucher.ref_type == proxy.$ms.constant.RefType.CAPayment && !x.credit_account.startsWith('111')) {
        return true;
      }
      // Phiếu thu rút tiền gửi ngân hàng, kho bạc
      // Phiếu thu rút dự toán nhập quỹ
      if (
        (voucher.ref_type == proxy.$ms.constant.RefType.CAReceiptPlanWithdraw ||
          voucher.ref_type == proxy.$ms.constant.RefType.CAReceiptWithdraw) &&
        !x.debit_account.startsWith('111')
      ) {
        return true;
      }
      // Chi tiền gửi
      // Chi tiền gửi mua tài sản cố định
      if (
        (voucher.ref_type == proxy.$ms.constant.RefType.BAWithDraw ||
          voucher.ref_type == proxy.$ms.constant.RefType.BAWithDrawFixedAsset) &&
        !x.credit_account.startsWith('112')
      ) {
        return true;
      }
      // Chuyển khoản kho bạc vào TK tiền gửi
      if (voucher.ref_type == proxy.$ms.constant.RefType.BUTransferDeposit && !x.debit_account.startsWith('112')) {
        return true;
      }

      // Ghi tăng TSCĐ từ QLTS.VN
      if (
        voucher.ref_type == proxy.$ms.constant.RefType.FAVoucherIncreament &&
        !(x.debit_account.startsWith('211') || x.debit_account.startsWith('213'))
      ) {
        return true;
      }

      return false;
    }

    async function commandClick(command) {
      const me = proxy;
      if (!validateBefore(proxy.model)) {
        return;
      }
      switch (command) {
        case this.$ms.constant.Command.Ok:
          await me.submitGridEditor();
          // validate control
          if (!me.validateComponents()) {
            nextTick(() => {
              me.focusFirstError();
            });
            return;
          }
          commonFn.mask();
          model.JsonDetail = JSON.stringify(details.value);
          model.$DataDetail = JSON.stringify(
            details.value
              .filter(x => x.checked == true)
              .map(x => ({
                ref_detail_id: x.ref_detail_id,
                quantity: x.quantity || 0,
                description: x.description || '',
                amount: x.amount || 0,
                unitprice: x.unitprice || 0,
                norm: x.norm || 0,
              })),
          );
          model.$RowPerPage = model.row_per_page || 0;
          model.row_per_page_dynamic = model.row_per_page;
          model.$AddEmptyRow = model.add_empty_row || 0;
          model.$ShowBudgetSourceProperty = model.show_budget_source_property;
          model.$PrintSubKindItem = model.print_sub_kind_item;
          model.$PrintBudgetSourceProperty = model.print_budget_source_property;
          model.$IsDetailBudgetItem = model.is_detail_budget_item;
          //  Xử lý nghiệp vụ Tích chọn :
          //  Thanh toán trực tiếp
          //  Thanh toán tạm ứng
          //  Tạm ứng
          if (
            [
              proxy.$ms.constant.RefType.BUVoucherListRealExpense,
              proxy.$ms.constant.RefType.BUVoucherListReceipExpense,
              proxy.$ms.constant.RefType.BUVoucherListOther,
            ].includes(model.ref_type) ||
            details.value.filter(x => x.cash_withdraw_type_id == proxy.$ms.constant.CashWithDrawType.Expense).length ==
              details.value.length ||
            ([
              proxy.$ms.constant.RefType.BUPlanWithdrawTransfer,
              proxy.$ms.constant.RefType.BUPlanWithdrawCash,
              proxy.$ms.constant.RefType.BUPlanWithdrawDeposit,
              proxy.$ms.constant.RefType.BUPlanWithdrawSalaryTransfer,
            ].includes(model.ref_type) &&
              proxy._formParam?.dataModel?.cash_withdraw_type_id == proxy.$ms.constant.CashWithDrawType.Expense)
          ) {
            model.type_pay = 1; // Tích chọn thanh toán trực tiếp
          } else if (
            [
              proxy.$ms.constant.RefType.BUVoucherListPlanned,
              proxy.$ms.constant.RefType.BUVoucherListNotPlanned,
            ].includes(model.ref_type)
          ) {
            model.type_pay = 3; // Tích chọn thanh toán tạm ứng
          } else if (
            details.value.filter(
              x =>
                x.cash_withdraw_type_id == proxy.$ms.constant.CashWithDrawType.EstimateAdvance ||
                x.cash_withdraw_type_id == proxy.$ms.constant.CashWithDrawType.EstimateNotYetAdvance,
            ).length == details.value.length ||
            ([
              proxy.$ms.constant.RefType.BUPlanWithdrawTransfer,
              proxy.$ms.constant.RefType.BUPlanWithdrawCash,
              proxy.$ms.constant.RefType.BUPlanWithdrawDeposit,
              proxy.$ms.constant.RefType.BUPlanWithdrawSalaryTransfer,
            ].includes(model.ref_type) && // Case ở các rút dự toán có: thanh toán trực tiếp/thanh toán tạm ứng/ thực chi
              (proxy._formParam?.dataModel?.cash_withdraw_type_id == proxy.$ms.constant.CashWithDrawType.EstimateAdvance ||
                proxy._formParam?.dataModel?.cash_withdraw_type_id == proxy.$ms.constant.CashWithDrawType.EstimateNotYetAdvance))
          ) {
            model.type_pay = 2; // Tích chọn vào tạm ứng
          } else {
            model.type_pay = 0; // Để trống không tích chọn
          }

          //Lưu lại params vào index db => load lại lần sau
          this._indexDb.set(this._formName + '_' + this._formParam.report_id, model);

          if (proxy._formParam && proxy._formParam.isPrintGrid) {
            proxy._formParam.data.formReportParam = model;
            let dataBaseDetail = proxy._formParam.data.dataDetail?.DvcFileM01Details;
            // Gán lại thông tin Thanh toán trên form tham số
            if (proxy.details && Array.isArray(proxy.details)) {
              proxy.details.forEach(item => {
                if (dataBaseDetail && Array.isArray(dataBaseDetail)) {
                  let baseItem = dataBaseDetail.find(x => x.detail_voucher_id == item.ref_detail_id);
                  if (baseItem) {
                    baseItem.amount = item.amount;
                    baseItem.unit_price = item.norm;
                    baseItem.unit_price_actual = item.unitprice;
                    baseItem.quantity = item.quantity;
                    baseItem.description = item.description;
                  }
                }
              });
            }
            proxy.view(proxy._formParam.data, proxy._formParam.formDVCName);
            proxy.hide();
            commonFn.unmask();
          } else {
            //Lấy thêm backRouter (áp dụng cho báo cáo có Drill Down in ở nhiều màn hình)
            this._report.backRouter = me._formParam?.backRouter || '/report';
            const backRouter = this._report.backRouter
              .split('/')
              .filter(x => x != '')
              .join('-');
            this._report.reportName = this._report.report_name;

            //Các tham số báo cáo lưu theo loại chứng từ
            const dataRefType = {
              show_budget_source_property: model.show_budget_source_property,
              print_sub_kind_item: model.print_sub_kind_item,
              print_date_voucher: model.print_date_voucher,
              print_budget_source_property: model.print_budget_source_property,
              add_transfer: model.add_transfer,
              lower_aquater_page: model.lower_aquater_page,
              show_unit: model.show_unit,
              add_empty_row: model.add_empty_row,
              date_and_ref_no: model.date_and_ref_no,
            };

            //Các tham số báo cáo lưu theo báo cáo không phân biệt mẫu ngang, mẫu dọc
            const paramReportCommon = {
              row_per_page: model.row_per_page,
              repeat_title_signature: model.repeat_title_signature,
            };

            //Lưu param trên server thực hiện load preview report
            //gọi lưu tham số và mở ra preview
            const param = {
              ReportId: this._report.report_id,
              ReportName: this._report.report_name,
              ReportList: this._report,
              KeyReload: this._report?.KeyReload,
              ...{
                DataParam: {
                  ...model, //Giữ nguyên lưu cả model chứ không rút gọn tham số vì trên code BE và báo cáo stimul sử dụng các key trong model (các ông thần dev code vớ vẩn) => Không kiểm soát được => Nhiều lỗi tiềm ẩn không biết
                  dataRefType: dataRefType, //Các tham số báo cáo lưu theo loại chứng từ
                  paramReportCommon: paramReportCommon, //Các tham số báo cáo lưu theo báo cáo không phân biệt mẫu ngang, mẫu dọc
                  BackRouter: backRouter, //BackRouter quay lại form detail đang in sau khi xem chi tiết chứng từ trên báo cáo
                },
              },
              ParamKey: proxy._formParam?.dataModel?.ref_id,
              IsSaveFormat: me.isSaveFormat, //Có lưu tham số in lần trước theo loại chứng từ không
              IsSaveCommon: me.isSaveCommon, //Có lưu tham số in lần trước theo báo cáo không
              ReportIdCommon: me.reportIdCommon, //Id chung cho báo cáo có 2 loại mẫu ngang, mẫu dọc cần lưu chung tham số in lần trước theo mẫu báo cáo
            };

            //Xóa key check lấy dữ liệu convert sau khi đã in lần đầu để code chạy đúng theo luồng trước khi convert
            delete param.DataParam.isDataConvert;

            popupUtil.show('ReportOfflineDesigner', { report: this._report.report, param: param });
            proxy.hide();
            commonFn.unmask();
            return;
          }

          break;
      }

      const {pushTrans} = collectionMonitor();
      let eventPrint = proxy.model.is_detail_budget_item ? 'PrintM01BudgetItemTrue' : 'PrintM01BudgetItemFalse';
      let labelPrint = 'In mỗi mục là 01 chứng từ';

      pushTrans(
        command,
        this._report.report_name + (proxy.model.is_detail_budget_item ? `/${labelPrint}` : ``),
        `${this._report.report_id}/${eventPrint}`,
      );

      //proxy.pushTrans(command);
    }

    function validateBefore(model) {
      if (details.value.filter(x => x.checked == true).length == 0) {
        showError(`Vui lòng chọn chi tiết số tiền`, 'Thông báo');
        return false;
      }
      return true;
    }

    /**
     * @private
     * Lấy tham số khi mở form chi tiết
     * */
    function getDetailParameter(formName, mode, defaultData) {
      const me = proxy;

      let param = {
        data: _.cloneDeep(defaultData) || null,
      };

      switch (mode) {
        case me.$ms.constant.FormState.Duplicate:
        case me.$ms.constant.FormState.Edit:
        case me.$ms.constant.FormState.View:
          param.id = proxy._formParam.id;
          break;
      }

      param.mode = mode;
      param.editMode = proxy._formParam.editMode;
      param.submit = proxy._formParam.submit;
      param.hasBindFormData = true;

      me.customDetailParam(param);

      return param;
    }

    /**
     * override gán dữ liệu chung theo ref_type
     * dqdat1 17.04.2023
     */
    function assignFormatRecentData(data, format) {
      let recent = JSON.parse(format);
      if (recent) {
        Object.assign(data, recent.dataRefType);
      }
    }

    // Cấu hình các field của grid
    const propsData = {
      description: {
        maxLength: 1024,
      },
    };
    /**
     * Xử lý gửi nhiều thông tin monitor
     * tbngoc 21.09.2023
     */
    function multipleMonitorHandler(pushTrans, command, screenName, screenCode) {
      if (proxy.model.not_show_summary_budget_sub_item) {
        screenName += '/Không hiển thị dòng tổng theo tiểu mục';
        screenCode += '/NotShowSummaryBudgetSubItem';
      }
      pushTrans(command, screenName, screenCode);
    }

    const changeDataBusiness = ($grid, col, rowIndex, metaData, callbackUpdateRow) => {
      const {dataField} = col;
      const {tracking} = metaData;

      switch (dataField) {
        case 'quantity':
        case 'unitprice':
        case 'norm':
          reCalculateAmount(dataField, col, rowIndex, metaData, callbackUpdateRow, tracking, $grid);
          break;
      }
    };

    /**
     * Tính lại tiền khi thay đổi thông tin đơn giá thực tế, định mức, số lượng
     * tbngoc 02.10.2023
     */
    function reCalculateAmount(dataField, col, rowIndex, metaData, callbackUpdateRow, tracking, $grid) {
      switch (dataField) {
        case 'norm':
          callbackUpdateRow(
            {
              unitprice: tracking.newVal,
            },
            rowIndex,
          );
          break;
        default:
          break;
      }
      const newAmount = $grid.dataView[rowIndex]?.quantity * $grid.dataView[rowIndex]?.unitprice;
      if (newAmount) {
        callbackUpdateRow(
          {
            amount: newAmount,
          },
          rowIndex,
        );
      }
    }

    /**
     * Lấy tham số báo cáo lần gần nhất
     * @param {*} formName
     * @returns
     * nmtuan4 13.12.2023
     */
    async function loadRecentData(formName) {
      if (formName) {
        try {
          const recentData = await this._indexDb.get(formName + '_' + this._formParam.report_id);
          if (recentData) {
            return recentData;
          }
        } catch (error) {
          console.log(error);
          //init lỗi
        }
      }
      return this.model;
    }

    return {
      model,
      comboboxDataRemote,
      showDisplay,
      showPayment,
      changeShowDisplay,
      changePayment,
      bindData,
      commandClick,
      columnDetails,
      details,
      getDefaultData,
      getDetailParameter,
      assignFormatRecentData,
      isSaveFormat,
      isSaveCommon,
      reportIdCommon,
      propsData,
      showDateAndRefNoCustom,
      multipleMonitorHandler,
      changeDataBusiness,
      loadRecentData
    };
  },
  computed: {
    ...mapGetters({
      postedDate: ModuleContext + '/PostedDate',
    }),
  },
});
</script>
<style lang="scss">
.report-param-payment-voucher-list-print-from-voucher-nd112020 {
  .report-body {
    display: flex;
    flex-direction: column;
    .title-3 {
      align-items: center;
      cursor: default;
      margin-left: -8px;
      .title-text {
        font-weight: $font-weight-semi-bold;
      }
    }
    .table-footer {
      z-index: 2;
    }
    .title-3 .icon-combo--dropdown {
      border-radius: 0 4px 4px 0;
      width: $input-height;
      height: $input-height;
      position: relative;

      &:before {
        content: '';
        position: absolute;
        width: $input-height;
        height: $input-height;
        display: inline-block;
        background: transparent url($ms-image-sprites) no-repeat -334px -45px;
        top: 0px;
        left: 0px;
        transform: rotate(270deg);
        transition: all 0.3s ease;
      }
      &.multiple {
        position: sticky;
        top: 0px;
      }

      &.expand {
        &:before {
          transform: rotate(0deg);
        }
      }
    }
    .seperator-line {
      border-top: 1px solid $secondary;
      width: 100%;
      &.tab-3 {
        border-top: 1px solid $secondary-active;
      }
    }
    .control-title {
      font-weight: $font-weight-medium;
    }
  }

  .ms-checkbox {
    &.left {
      margin-left: -4px !important;
    }
    input[type='checkbox']:disabled {
      background-color: $ms-grey;
    }
  }
  .align-center {
    align-items: center;
  }
  .footer-total-count .text-center {
    font-weight: $font-weight-semi-bold;
  }
  .ms-footer th {
    background: $ms-grey !important;
  }

  .ms-table th .text-right {
    margin-right: 10px;
  }
  .get-default {
    align-items: center;
    color: $blue;
    width: 216px;
    cursor: pointer;
    .back-default {
      &::before {
        background-position: -98px -337px;
      }
    }
  }
  td.multiple-cell,
  td.multiple-cell:hover {
    background-color: $ms-grey !important;
  }
  .width-595 {
    width: 595px;
  }
}
</style>
